import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "c-sidemenu",
  "aria-label": "Side menu"
}

import { computed } from 'vue';
import SideMenuOverlay from './SideMenuOverlay.vue';
import { useSideMenuStore, type MenuType } from '../stores/sideMenuStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'SideMenu',
  props: {
    type: {}
  },
  setup(__props: any) {

const props = __props;

const store = useSideMenuStore();
const isOpen = computed(() => store.activeMenu.value === props.type);

const close = () => {
  store.closeMenu();
};

const open = () => {
  store.openMenu(props.type);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", {
      class: "c-sidemenu__button",
      onClick: open
    }, [
      _renderSlot(_ctx.$slots, "button")
    ]),
    _createVNode(SideMenuOverlay, {
      "is-open": isOpen.value,
      placement: "right",
      onClose: close,
      class: "c-sidemenu"
    }, {
      body: _withCtx(() => [
        _renderSlot(_ctx.$slots, "body")
      ]),
      _: 3
    }, 8, ["is-open"])
  ]))
}
}

})